import { css, keyframes } from '@emotion/react'

const bounce = keyframes`
  0% {
    transform: scale(0);
  }

  40% {
    transform: scale(1.6);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1.4);
  }
`

const bouncyCss = css`
  .bouncy-enter {
    animation: ${bounce} 1s ease-in-out;
  }
`

export { bouncyCss }
